module.exports = __webpack_public_path__ + "img/bos.f3bf7664.png";